import { useState } from "react";
import { PageHeader, useApi } from "@/components/common";
import AuditTable from "@/components/AuditTable";
import { useT } from "@/i18n";

export default function AuditView() {
  const { t } = useT();
  const [filters, setFilters] = useState({ q: "", severity: "", page: 1 });
  const qs = new URLSearchParams({ page: filters.page, limit: 25, ...(filters.q && { q: filters.q }), ...(filters.severity && { severity: filters.severity }) }).toString();
  const audit = useApi(`/tenant/audit?${qs}`);
  return (
    <div>
      <PageHeader title={t("audit.title")} subtitle={t("lbl.immutable_record_of_logins_permission_ch")} testId="audit-page" />
      <AuditTable data={audit.data} loading={audit.loading} filters={filters} setFilters={setFilters} />
    </div>
  );
}
